// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"94623392","732":"530d01fe","977":"fd9938e0"}[chunkId] + ".chunk.js";
};